import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';

const URI = '/auth';
const URIUser = '/user';

/**
 * @see https://labs.pmweb.com.br/docs/context-v3/#api-Auth-auth
 * @description Authenticate user
 */
export const postLogin = data => {
  const tokenV3 = store.state.auth.tokenV3;
  return axios.post(`${URI}/login`, data, {
    baseURL: endpointVersion('v3'),
    headers: { 'content-type': 'multipart/form-data', Authorization: `Bearer ${tokenV3}` },
  });
};

/**
 * @description Authenticate user using federation
 */
export const postFederatedLogin = data => {
  return axios.get(`${URI}/token`, {
    baseURL: endpointVersion('v3'),
    params: data,
  });
};

/**
 * @see https://labs.pmweb.com.br/docs/context/#api-Login-password_forgot
 * @description Post forgot password
 */
export const postForgotLogin = data => {
  const tokenV3 = store.state.auth.tokenV3;
  return axios.post(`${URIUser}/passwordForgot`, data, {
    baseURL: endpointVersion('v3'),
    headers: {
      Authorization: `Bearer ${tokenV3}`,
      'content-type': 'multipart/form-data',
    },
  });
};

/**
 * @see https://api-context.pmweb.com.br/v3/auth/verifyEmail
 * @description Verify if is fedarated login
 */
export const getVerifyEmail = email => {
  const brand = store.getters.selectedBrand;
  const tokenV3 = store.state.auth.tokenV3;

  return axios
    .get('/auth/verifyEmail', {
      baseURL: endpointVersion('v3'),
      params: {
        brand: brand.id,
        email: email,
      },
      headers: { Authorization: `Bearer ${tokenV3}` },
    })
    .then(response => response?.data);
};
